import { render, staticRenderFns } from "./MyContactInformation.vue?vue&type=template&id=4163315a&scoped=true&"
import script from "./MyContactInformation.vue?vue&type=script&lang=js&"
export * from "./MyContactInformation.vue?vue&type=script&lang=js&"
import style0 from "./MyContactInformation.vue?vue&type=style&index=0&id=4163315a&lang=scss&scoped=true&"
import style1 from "./MyContactInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163315a",
  null
  
)

export default component.exports